import React from 'react';
import PropTypes from 'prop-types';
//import { getUrl, getDescText, getPublishDate, getEventDate, cacheFunc } from '../../common/services/builders';
import { getUrl, getDescText } from '../../common/services/builders';

function ListingCard({ entry }) {
    return (
        <div className="column large-4">
            <article className="ui-card" style={{minHeight: 460 + 'px'}}>
                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderImage(entry)}></div>
                </div>
                <div className="ui-card__content  text-center">
                    <h3 className="ui-card__heading"><a href={getUrl(entry)}>{entry.title}</a></h3>
                    <p className="ui-card__text">{getDescText(entry)}</p>
                    <div className="ui-card__tags">
                        {renderTags(entry)}
                    </div>
                </div>
            </article>
        </div>
    );

}
function renderImage(entry){
    let styles = {};
    if(entry.thumbnailImage != null && entry.thumbnailImage != ''){
        styles = {backgroundImage: `url(${entry.thumbnailImage.asset.sys.uri})`};
    }
    else if(entry.heroImage != null && entry.heroImage != ''){
        styles = {backgroundImage: `url(/CachedImage.axd?ImageName=${entry.heroImage.asset.sys.uri}&ImageHeight=300&ImageWidth=500)`};
    }
    else{
        styles = {backgroundImage: `url(/CachedImage.axd?ImageName=/site-elements/images/hero/hero-slider-1.jpg&ImageHeight=300&ImageWidth=500)`};
    }
    return styles;
}
function renderTags(entry) {
    if(entry && entry.industry){
        if(!Array.isArray(entry.industry)){
            return <span className="tag">{entry.industry.name}</span>;
        }
        else{
            return entry.industry.map((e, index) => <span key={index} className="tag">{e.name}</span>);
        }
    }
    else{
        return <span className="tag">All</span>;
    }
}

ListingCard.propTypes = {
    entry: PropTypes.object,
};

export default ListingCard;